import type { ArgoCDApplicationResource, EnvironmentV2Resource } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { EnvironmentsChipList } from "~/areas/infrastructure/components/ArgoCDInstances/components/EnvironmentsChipList";
type ArgoCDApplicationEnvironmentsChipListProps = {
    application: ArgoCDApplicationResource;
    environments: EnvironmentV2Resource[];
};
export const ArgoCDApplicationEnvironmentsChipList = (props: ArgoCDApplicationEnvironmentsChipListProps) => {
    const environmentIds = [...new Set(props.application.Sources.map((src) => src.EnvironmentId).filter((id) => id !== null))];
    return <EnvironmentsChipList environmentIds={environmentIds} environments={props.environments}/>;
};
